let isPlaying = false,
  isStopped = true,
  isPaused = false,
  audio = {},
  _player = null;

const qTrack = (track) => {
  audio = track;
};

const playAudio = (track) => {
  isPlaying = true;
  isPaused = false;
  isStopped = false;
  audio = track;
};

const pausePlayback = () => {
  isPlaying = false;
  isPaused = true;
};

const resumePlayback = () => {
  isPaused = false;
  isPlaying = true;
  isStopped = false;
};

const stopPlayback = () => {
  isStopped = true;
  isPlaying = false;
  isPaused = false;
};

const storeInstance = (wf) => {
  _player = wf;
};

const clearInstance = () => {
  _player = null;
};

export const useAudioPlayer = () => {
  return {
    audio,
    isPlaying,
    pausePlayback,
    playAudio,
    isPaused,
    isStopped,
    resumePlayback,
    stopPlayback,
    qTrack,
    storeInstance,
    clearInstance,
  };
};
